import React, { useContext } from 'react';
import { StyledPrimaryMenuContainer } from 'baseui/app-nav-bar/styled-components';
import AuthContext from '../shared/AuthContext';
import NotificationBell from '../notifications/NotificationBell';
import NavUserMenu from './NavUserMenu';

/** Desktop main nav + notification bell + account menu. */
export default function NavPrimaryMenuContainer({ children, ...props }) {
  const { user } = useContext(AuthContext);

  return (
    <StyledPrimaryMenuContainer {...props}>
      {children}
      {user && (
        <div className="app-nav-notifications-slot">
          <NotificationBell />
        </div>
      )}
      <NavUserMenu />
    </StyledPrimaryMenuContainer>
  );
}
